import React from 'react'
import { Input } from 'reactstrap'

const FormItem = ({ title, formData, setFormData, id, icon, name, type, keyT, onChange }) => {
    const handleChange = (e) => {
        if (type === "file") {
            if (e.target.files && e.target.files.length > 0) {
                const file = e.target.files[0];
                setFormData({
                    ...formData,
                    [keyT]: [{ file: file }]
                });
            }
        } else {
            setFormData({ ...formData, [keyT]: e.target.value });
        }
        if (onChange) {
            onChange();
        }
    };

    return (
        <div className='form-item'>
            <label>{title}</label>
            <div className='form-element'>
                {icon}
                <Input
                    id={id}
                    name={name}
                    type={type}
                    value={type === "file" ? null : formData[keyT]}
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}

export default FormItem